module.exports = __webpack_public_path__ + "static/media/trash.4160b62a.svg";